'use client';

import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import OperationsFilterAlt from '@energy-retailer/icons/components/operations-filter-alt';

import { PlanFlowStep } from './step';
import type { FilteringSchemaType } from './form-schema';
import { Button } from '../button';
import { FilterModal } from './filter-modal';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';
import { EnergyType } from '@energy-retailer/constants';

const PlanFlowSteps = () => {
  const { watch } = useFormContext<FilteringSchemaType>();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const {
    steps,
    currentStepNumber,
    electricityPlanId,
    gasPlanId,
    electricityPlanName,
    gasPlanName,
    goToStep,
  } = useJoinFormStore();

  const preferences = watch('preferences');

  const openFilterModal = () => {
    setIsFilterModalOpen(true);
  }

  const closeFilterModal = () => {
    setIsFilterModalOpen(false);
  }

  const onClickPlan = (stepNumber: number) => {
    if (stepNumber === 0 && currentStepNumber === 1) {  // you can always go back a step
      goToStep(stepNumber);
    } else if (
      stepNumber === 1 
      && currentStepNumber === 0
      && (
        (steps[0]?.fuel === EnergyType.Electricity && electricityPlanId) 
        || (steps[0]?.fuel === EnergyType.Gas && gasPlanId)
      )) { // you can only go forward if you have selected a plan
      goToStep(stepNumber);
    }
  }

  return (
    <div className="grid grid-cols-12">
      <div className='flex gap-d col-span-10 col-start-2 lg:justify-center'>
        {steps.map((value, i) => (
          <PlanFlowStep
            id={value.fuel}
            key={value.fuel}
            labelHeader={value.fuel}
            labelSubHeader={value.fuel === EnergyType.Electricity ? electricityPlanName : gasPlanName}
            isActive={currentStepNumber === i}
            onClick={() => onClickPlan(i)}
            stepNumber={i + 1}
            disabled={false}
          />
        ))}
        <div className="lg:hidden ml-auto">
          <Button
            variant="icon"
            iconPosition="right"
            className='font-medium'
            icon={<OperationsFilterAlt />}
            count={preferences?.length}
            onClick={() => openFilterModal()}>
            Filter
          </Button>
        </div>
      </div>
      <FilterModal isModalOpen={isFilterModalOpen} openModal={openFilterModal} closeModal={closeFilterModal} />
    </div>
  );
};

export { PlanFlowSteps };
